import { render } from "./familyInvitationModal.vue?vue&type=template&id=5c3e44bb&scoped=true&ts=true"
import script from "./familyInvitationModal.vue?vue&type=script&lang=ts"
export * from "./familyInvitationModal.vue?vue&type=script&lang=ts"

import "./familyInvitationModal.vue?vue&type=style&index=0&id=5c3e44bb&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c3e44bb"]])

export default __exports__